module.exports = __webpack_public_path__ + "img/Ins_Current_L2.d083ec5b.jpeg";